import request from './base'

export const getDepartmentList = (params) => {
    return request.post("/merchant/v1/account/list", params)
}

export const departmentCreateAccount = (params) => {
    return request.post("/merchant/v1/account/create", params)
}

export const departmentModifyAccount = (params) => {
    return request.post("/merchant/v1/account/modify", params)
}

export const departmentDeleteAccount = (params) => {
    return request.post("/merchant/v1/account/delete", params)
}

export const departmentMapOptions = (params) => {
    return request.post("/merchant/v1/account/mapOptions", params)
}

export const departmentMapAuth = (params) => {
    return request.post("/merchant/v1/account/mapAuth", params)
}

export const departmentMapRemove = (params) => {
    return request.post("/merchant/v1/account/mapRemove", params)
}

export const departmentSystemInfo = (params) => {
    return request.post("/merchant/v1/account/systemInfo", params)
}

export const departmentSystemInfoModify = (params) => {
    return request.post("/merchant/v1/account/systemInfoModify", params)
}


// WEBPACK FOOTER //
// ./src/api/account.js